import { render } from "./ItemGroup.vue?vue&type=template&id=675b3af4&ts=true"
import script from "./ItemGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemGroup.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/item/ItemGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "675b3af4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('675b3af4', __exports__)) {
    api.reload('675b3af4', __exports__)
  }
  
  module.hot.accept("./ItemGroup.vue?vue&type=template&id=675b3af4&ts=true", () => {
    api.rerender('675b3af4', render)
  })

}


export default __exports__